// ComplaintSampleInspection Configuration - UNIFIED APPROACH
import { createTrackingConfig } from '../../../components/generic/labels';
import { tableConfig, uiConfig } from '../../../config/appConfig';

export const complaintSampleInspectionConfig = {
  entityName: 'ComplaintSampleInspection',
  api: { 
    baseEndpoint: '/complaint-sample-inspection', 
    endpoints: { 
      list: '', 
      create: '', 
      update: (id) => `/${id}`, 
      delete: (id) => `/${id}`, 
      getById: (id) => `/${id}` 
    }, 
    lookupEndpoints: {} 
  },
  ui: { 
    drawerWidth: '600px', 
    defaultPageSize: tableConfig.defaultPageSize, 
    pageSizeOptions: tableConfig.pageSizeOptions, 
    defaultTableDensity: tableConfig.defaultDensity, 
    requiredFieldStyle: uiConfig.requiredFieldStyle 
  },
  service: { 
    name: 'complaintSampleInspectionService', 
    methods: { 
      getAll: 'getAllComplaintSampleInspections', 
      getById: 'getComplaintSampleInspectionById', 
      create: 'createComplaintSampleInspection', 
      update: 'updateComplaintSampleInspection', 
      delete: 'deleteComplaintSampleInspection', 
      validate: 'validateData' 
    } 
  },
  fields: [
    { 
      name: 'id', 
      label: 'ID', 
      type: 'hidden', 
      table: false, 
      filterable: false 
    },
    { 
      name: 'name', 
      label: 'Inspection Type Name', 
      type: 'text', 
      required: true, 
      placeholder: 'Enter inspection type (ΟΠΤΙΚΟΣ, ΑΛΛΟ)', 
      table: { 
        header: 'Inspection Type', 
        width: '200px', 
        sortable: true 
      }, 
      filterable: true, 
      validation: { 
        required: true, 
        minLength: 2, 
        maxLength: 100 
      } 
    },
    { 
      name: 'description', 
      label: 'Description', 
      type: 'textarea', 
      required: false, 
      placeholder: 'Describe this inspection type', 
      table: { 
        header: 'Description', 
        width: '250px', 
        sortable: false 
      }, 
      filterable: true, 
      validation: { 
        required: false, 
        maxLength: 500 
      }, 
      rows: 3 
    },
    { 
      name: 'isActive', 
      label: 'Active', 
      type: 'switch', 
      required: false, 
      defaultValue: true, 
      table: { 
        header: 'Status', 
        width: '100px', 
        sortable: true, 
        cellRenderer: 'boolean' 
      }, 
      filterable: true, 
      validation: { 
        required: false 
      }, 
      switchLabel: 'Inspection type is active' 
    },
    { 
      name: 'record_order', 
      label: 'Display Order', 
      type: 'number', 
      required: false, 
      table: { 
        header: 'Order', 
        width: '80px', 
        sortable: true 
      }, 
      validation: { 
        required: false, 
        min: 1, 
        max: 999, 
        integer: true 
      }, 
      step: 1, 
      decimals: 0, 
      allowNegative: false 
    },
    { 
      name: 'color', 
      label: 'Display Color', 
      type: 'color', 
      required: false, 
      table: { 
        header: 'Color', 
        width: '100px', 
        sortable: false, 
        cellRenderer: 'color' 
      }, 
      validation: { 
        required: false 
      } 
    }
  ],
  get tableColumns() { 
    return this.fields
      .filter(field => field.table !== false && !field.hidden)
      .map(field => ({
        key: field.name,
        header: field.table?.header || field.label,
        width: field.table?.width || 'auto',
        sortable: field.table?.sortable !== false,
        displayField: field.table?.displayField || field.name,
        cellRenderer: field.table?.cellRenderer || 'default'
      })); 
  },
  filterableFields: ['name', 'description', 'isActive'],
  filterGroups: [
    { 
      name: 'basic', 
      label: 'Basic Filters', 
      fields: ['name', 'isActive'] 
    }, 
    { 
      name: 'advanced', 
      label: 'Advanced Filters', 
      fields: ['description'] 
    }
  ],
  customSortOrders: { 
    isActive: [true, false], 
    record_order: 'asc' 
  },
  messages: { 
    loading: 'Loading inspection types...', 
    noData: 'No inspection types found.', 
    saveSuccess: 'Inspection type saved successfully!', 
    deleteConfirm: 'Are you sure you want to delete this inspection type?' 
  },
  layout: { 
    mode: 'sections', 
    sections: [
      { 
        id: 'basic', 
        title: 'Inspection Type Information', 
        icon: '🔍', 
        columns: 2, 
        fields: [
          { name: 'name' }, 
          { name: 'isActive' }, 
          { name: 'record_order' }, 
          { name: 'color' }
        ] 
      }, 
      { 
        id: 'details', 
        title: 'Additional Details', 
        icon: '📝', 
        columns: 1, 
        fields: [
          { name: 'description' }
        ] 
      }
    ] 
  },
  trackingSection: createTrackingConfig('ComplaintSampleInspection'),
  labels: { 
    singular: 'Sample Inspection', 
    plural: 'Sample Inspections', 
    addButton: 'Add Inspection Type', 
    pageTitle: 'Sample Inspection Management' 
  },
  fieldsToRemove: ['id', 'createdAt', 'updatedAt', 'createdById', 'updatedById', 'complaints'],
  exportFileName: 'complaint-sample-inspections',
  transformData: (data) => { 
    const transformed = { ...data }; 
    if (transformed.record_order !== undefined) { 
      if (transformed.record_order === '' || transformed.record_order === null) { 
        delete transformed.record_order; 
      } else { 
        const numValue = parseInt(transformed.record_order, 10); 
        if (!isNaN(numValue)) { 
          transformed.record_order = numValue; 
        } else { 
          delete transformed.record_order; 
        } 
      } 
    } 
    return transformed; 
  },
  validateField: null
};

